import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import PageBack from "../components/buttons/page-back";
import {connect} from "react-redux";
import {popupShow} from "../../libs/redux/actions/popup";
import {api, apis, msg, rd, sendGet, throws, type_popup} from "../../vars/rd";
import ChannelItem from "../components/elements/channel.item";
import CategoryTheme from "../components/buttons/category.theme";
import {preloaderHide, preloaderShow} from "../../libs/redux/actions/preloader";
import DaoChannel from "../../modules/dao/channel";

class SearchTheme extends Component {
    is_loading = false;

    scrollPosition = 0;
    scrollHandler;
    scrollRef;
    constructor(props) {
        super(props);

        this.scrollHandler = this.eventScroll.bind(this);

        const data = props.match.params.id;
        if(!data) props.history.goBack();

        this.state = {
            data: (data === 'all' ? [] : [data]),
            channels: [],
            page: 0,
            page_count: 0,
            total: 0
        }
    }

    /**
     * 페이지 마운트
     */
    componentDidMount() {
        this.filterChange(this.state.data);
        if(this.scrollRef) this.scrollRef.addEventListener('scroll', this.scrollHandler);
    }

    /**
     * 페이지 언마운트
     */
    componentWillUnmount() {
        if(this.scrollRef) this.scrollRef.removeEventListener('scroll', this.scrollHandler);
        this.scrollRef = null;
    }

    get dispatch() {
        return this.props.hasOwnProperty("dispatch") ? this.props.dispatch : () => {};
    }

    /**
     * 스크롤 이벤트
     * @param e
     */
    eventScroll(e) {
        try {
            const scroller = e.currentTarget;
            if(scroller) {
                const scrollHeight = scroller.scrollHeight;
                const height = scroller.offsetHeight;
                const top = scroller.scrollTop;
                if(top > this.scrollPosition) {
                    const gap = scrollHeight - (height + top);
                    if(gap < 30) this.channelNext();
                }
                this.scrollPosition = top;
            }
        } catch (e) {}
    }

    reset() {
        this.filterChange([]);
    }

    filter() {
        if(this.dispatch) {
            this.dispatch(
                popupShow(
                    type_popup.theme_filter,
                    this.state.data,
                    (data) => this.filterChange(data)
                )
            );
        }
    }

    /**
     * 카테고리 닫기
     * @param category {DaoCategory}
     */
    filterCategory(category) {
        if(category) {
            const id = category.proid.toString();
            const index = this.state.data.indexOf(id);
            this.filterChange(this.state.data.filter((_, idx) => idx !== index));
        }
    }

    /**
     * @param data {string[]}
     */
    filterChange(data) {
        this.setState(
            { data, channels: [], page: 0, page_count: 0, total: 0 },
            async () => {
                await this.channelData(data, 1)
            }
        );
    }

    /**
     * 채널데이터 다음 페이지 존재여부
     * @returns {boolean}
     */
    get channelHasNext() {
        return this.state && ((this.state.total || 0) > (this.state.page_count || 0));
    }

    /**
     * 채널데이터 다음 인출
     * @returns
     */
    channelNext() {
        if (this.channelHasNext && !this.is_loading) {
            this.is_loading = true;
            const page = this.state.page + 1;
            this.channelData(this.state.data, page).then();
        }
    }

    /**
     * 채널데이터 인출
     * @param data {string[]}
     * @param page {number}
     * @returns {Promise<void>}
     */
    async channelData(data, page) {
        try {
            if(this.state.page !== page) {
                this.dispatch(preloaderShow());
                const url = api(apis.channel_search, {
                    serviceid: rd.user.serviceid,
                    groupid: rd.user.groupid,
                    search_key: 'theme',
                    search_val: data.length ? data.join(",") : 'all',
                    p: page,
                });
                sendGet(url)
                    .then(json => {
                        if(!json || json.result !== "OK") throws(msg().api_fail);
                        if(json.status === "OK") {
                            const page_count = json.page_count;
                            const total = json.total;
                            const channels = [];
                            if (json.hasOwnProperty('items') && json.items.length) {
                                for (let i = 0; i < json.items.length; i++) {
                                    channels.push(new DaoChannel(json.items[i]));
                                }
                            }

                            this.setState({channels: [...this.state.channels, ...channels], page, page_count, total}, () => {
                                this.is_loading = false;
                            });

                        }
                    })
                    .finally(() => {
                        this.dispatch(preloaderHide());
                    });
            }
        } catch (e) {}
    }

    render() {
        return (
            <div className="search-wrap mobile-search">
                <div className="search-box3">
                    <h2>
                        <PageBack />
                        테마별 채널
                    </h2>
                    <div className="search-bar">
                        <div className="theme">
                            <div className="all_item" onClick={() => this.reset()}>
                                전체
                            </div>
                            <div className="filter">
                                <div className="item">
                                    <a onClick={() => this.filter()}>
                                        <span className="yellow"></span>필터<img src="/images/icon-filter.png" alt={''} />
                                    </a>
                                </div>
                            </div>
                            <div className="list">
                                {
                                    rd.category.theme.map((category, index) => {
                                        return this.state.data.indexOf(category.proid.toString()) > -1 ?
                                            <CategoryTheme key={index} category={category} selectable={true} closable={true} onChange={this.filterCategory.bind(this)} /> :
                                            null;
                                    })
                                }
                            </div>
                        </div>
                        {
                            this.state.data.length > 0 ?
                                <div className="btn-reset" onClick={() => this.reset()}>초기화</div> :
                                null
                        }

                    </div>
                </div>
                <div className="search-result search-result3" ref={el => {
                    this.scrollRef = el;
                }}>
                    {
                        this.state.channels.map((channel, i) => {
                            return (
                                <ChannelItem data={channel} key={i} themeCallback={this.filterChange.bind(this)} />
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}

export default connect()(withRouter(SearchTheme));


// WEBPACK FOOTER //
// ./src/pages/search/theme.jsx